<template>
	<div class="captions-container" :class="{ empty: !captions.length }">
		<div class="captions" v-if="captions.length">
			<div class="caption-item" v-for="caption in captions" :key="caption.id">
				<span class="caption-user" v-text="caption.userName + ':'" />
				<span class="caption-text" v-text="caption.text" />
			</div>
		</div>
		<div class="captions-empty" v-if="!captions.length">
			<Spinner v-if="isLoading" />
			<ClosedCaptioningIcon type="solid" v-if="!isLoading" />
			<div
				v-t="
					isLoading
						? 'meetings_captions_loading_label'
						: 'meetings_captions_empty_label'
				"
			/>
		</div>
	</div>
</template>

<script>
import { getCaptions } from './data/store'
import { Spinner } from '@/components/common'
import { ClosedCaptioningIcon } from '@/icons'

export default {
	name: 'Captions',
	components: { Spinner, ClosedCaptioningIcon },
	data() {
		return {
			captions: [],
			isLoading: true,
		}
	},
	created() {
		this.$onEventBus('captionAdded|captionUpdated', () => {
			this.captions = getCaptions().slice().reverse()
		})
		this.captions = getCaptions().slice().reverse()
	},
	mounted() {
		this.$onEventBus('videosessionUpdated', (videosession) => {
			if (videosession.captions_enabled) {
				this.isLoading = false
			}
		})
	},
}
</script>

<style lang="scss" scoped>
@import 'src/sass/variables';

.captions-container {
	grid-area: captions;
	overflow: hidden;

	&.empty {
		@include flex-column-center;
		justify-content: center;
	}

	.captions {
		width: 100%;
		height: 100%;
		overflow: hidden;
		display: flex;
		flex-direction: column-reverse;

		.caption-item {
			width: 100%;
			margin-bottom: 4px;
			&:first-child {
				margin-bottom: 0;
			}
			.caption-user {
				@include fontFamily(900);
				margin-right: 6px;
			}
			.caption-text {
				@include fontFamily(400);
			}
		}
	}

	.captions-empty {
		@include flex-column-center(8px);
		color: var(--neutral-500);
		.pronto-spinner {
			font-size: 40px;
		}
		.pronto-icon {
			font-size: 43px;
		}
	}
}
</style>
